import { render, staticRenderFns } from "./MxFullDate.vue?vue&type=template&id=407a32d8&"
import script from "./MxFullDate.vue?vue&type=script&lang=js&"
export * from "./MxFullDate.vue?vue&type=script&lang=js&"
import style0 from "./MxFullDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports